import React from 'react';
import { Link } from 'react-router-dom';
import withUnreadConversationsCount from '../../../components/HOC/withUnreadConversationsCount';

import galleriesImg from '../../../assets/dashboard-icons/galleries.png';
import insightsImg from '../../../assets/dashboard-icons/insights.png';
import videosImg from '../../../assets/dashboard-icons/videos.png';
import Messages from '../../../assets/dashboard-icons/mesages.png';

const navigationItems = [
  // {
  //     icon: <PermIdentity fontSize="inherit" />,
  //     label: 'My Profile',
  //     link: '/dashboard/edit'
  // },
  // This is removed only for the launch - uncomment the code above to enable edit profile option on mobile
  {
      icon: Messages,
      label: 'Messages',
      link: '/dashboard/private-chat'
  },
];

@withUnreadConversationsCount
class QuickLinks extends React.Component {
  render () {
    const { numOfUnreadConversations: num } = this.props;
    return (
      <>
        <div className="dashboard-section-title col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <h3>Quick Links</h3>
        </div>
        {navigationItems.map(item => {
          let labelClassName = 'dashboard-label';
          if (item.label === 'Messages' && num > 0) {
            labelClassName += ' dashboard-label--important dashboard-label--fill-width';
          }
          const content = (
            <>
              <div className="ico">
                <img
                  src={item.icon}
                  alt={`${item.label} link`}
                />
              </div>
              <div className={labelClassName}>
                <div>
                  {item.label}
                </div>
                {item.label === 'Messages' && num > 0 && (
                  <div
                    title={`${num} unread conversation${num > 1 ? 's' : ''}`}
                    className="dashboard-unread-messages-count">
                    {num}
                  </div>
                )}
              </div>
            </>
          );
          return (
            <div
              key={item.label}
              className="col-xs-12 col-sm-6 col-md-6 col-lg-6 dashboard-quick-links">
              <div className="dashboard-quick-link">
                <Link
                  className="tile"
                  to={item.link}
                  target={ item.target ? item.target : null}>
                  {content}
                </Link>
              </div>
            </div>
          );
        })}
      </>
    );
  }
}

export default QuickLinks;